import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      skipOnVariables: false,
    },
    keySeparator: '::::',
    nsSeparator: '::::',
    // run following commands and validate the existing json file with generated json file
    // pnpm i18next-scanner 'apps/**/*.{js,ts,jsx,tsx}'
    // pnpm i18next-scanner 'packages/**/*.{js,ts,jsx,tsx}'
    resources: {
      en: {
        translation: enTranslation,
      },
    },
  });

export const trans = (
  key: keyof typeof enTranslation,
  param?: Record<string, any>
) => {
  return i18n.t(key, param);
};

export default i18n;
